export default __webpack_public_path__ + "static/media/Efficient Process.649b6133.svg";